import React from 'react'
import InfiniteScroll from 'react-infinite-scroller'
import { map } from 'lodash-es'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'
import { motion } from 'framer-motion'
import { useRouter } from 'next/router'
import { ImageIcon } from 'lucide-react'
import ImageInfo from '@/components/HomePage/ImageInfo'
import AIImage from './AIImage'
import { Skeleton } from '@/components/ui/skeleton'
import { Button } from '@/components/ui/button'

const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
}

const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.1,
    },
  },
}

const ImageList = ({ images, hasMore, onChange, setImages }) => {
  const router = useRouter()
  const { image_id } = router.query

  return (
    <div className="relative">
      {/* 背景装饰 */}
      <div className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
        <div className="bg-primary/3 absolute -left-[10%] top-[10%] h-[40rem] w-[40rem] rounded-full dark:bg-primary/5" />
        <div className="bg-blue-500/3 absolute -right-[10%] top-[30%] h-[35rem] w-[35rem] rounded-full dark:bg-blue-500/5" />
      </div>

      {images && images.length === 0 ? (
        <motion.div
          className="my-16 flex flex-col items-center justify-center gap-4 text-center"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          <div className="flex h-32 w-32 items-center justify-center rounded-full bg-muted/20 dark:bg-muted/10">
            <ImageIcon className="h-16 w-16 text-muted-foreground/50" />
          </div>
          <h3 className="text-xl font-medium text-foreground">暂无图片</h3>
          <p className="max-w-md text-muted-foreground">尝试创建新的AI图片，或者调整您的筛选条件来查看更多结果</p>
          <Button variant="outline" className="mt-4" onClick={() => router.push('/creation')}>
            创建新图片
          </Button>
        </motion.div>
      ) : (
        <motion.div variants={staggerContainer} initial="initial" animate="animate" className="min-h-[50vh]">
          <InfiniteScroll
            pageStart={0}
            loadMore={onChange}
            hasMore={hasMore}
            threshold={150}
            loader={
              <div className="grid gap-4 px-1 py-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5" key="spin">
                {[1, 2, 3, 4, 5].map((i) => (
                  <div key={i} className="overflow-hidden rounded-xl">
                    <Skeleton className="aspect-square w-full" />
                  </div>
                ))}
              </div>
            }
          >
            <ResponsiveMasonry columnsCountBreakPoints={{ 576: 2, 768: 3, 992: 4, 1200: 5 }} className="px-1 py-2">
              <Masonry gutter="16px">
                {map(images, (image, idx) => (
                  <motion.div key={+idx} variants={fadeInUp} transition={{ duration: 0.4 }}>
                    <AIImage image={image} setImages={setImages} images={images} />
                  </motion.div>
                ))}
              </Masonry>
            </ResponsiveMasonry>
          </InfiniteScroll>
        </motion.div>
      )}
      <ImageInfo image_id={image_id} images={images} />
    </div>
  )
}

export default ImageList
